export enum StructureType {
  Undefined = 0,
  Folder = 1,
  Document = 2,
  LoopName = 3,
  LoopContainer = 4,
  LoopNode = 5
}
